import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


/**
 * Base UI Components to be imported, 
 * this mandatory to be included so that the View Module Pages can be rendered via baseUI
 */
import { BaseUIContainerComponent } from '../../../BaseFramework/base-ui/base-ui-container/base-ui-container.component'
import { AppLayoutComponent } from '../../../BaseFramework/base-ui/app-layout/app-layout.component'
////BASEUI Modules End

import { TransactionDetailsComponent } from './transaction-details/transaction-details.component'
import { ClaimsAuthenticationGuard } from '../claims-guards'


var routeList = [
    {
        path: 'details',
        component: TransactionDetailsComponent,
        data: {
            breadcrumb: 'Transaction',
            transactionAllowed: true
        },
    },
    {
        path: 'enquiry',
        component: TransactionDetailsComponent,
        data: {
            breadcrumb: 'Enquiry',
            transactionAllowed: false
        },
    },
];

const routes: Routes = [
    ...routeList
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: []
})

export class TransactionRoutingModule { } 
